import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import Button from "../../shared/button/Btn"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import InputText from "../../shared/input/new/InputText"
import InputMail from "../../shared/input/new/InputMail"
import InputPhoneFormat from "../../shared/input/new/InputPhoneFormat"
import PageTopTitle from "../../shared/PageTopTitle"
import { setIsSearchCompany, setSearchCompany, updateCompanyProject } from "../../../features/isOrtaklari/isOrtaklariSlice"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 700px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-block: 20px;
        border-radius: 10px;
        
        p{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-md);
            margin-block: 5px;
        }
        .form-container{
            padding: 20px;
            width: 70%;
            margin: 0 auto;
            .form{
                display: flex;
                align-items: center;
                flex-direction: column;
                width: 100%;
                gap: 15px;
                .input-grp{
                    width: 100%;
                }
                .info{
                    display: block;
                    font-size: 12px;
                    margin-top: 3px;
                }
                
            }
            .bilgi{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
                line-height: 20px;
                margin-top: 20px;
                span{
                    color: var(--color-main);
                    cursor: pointer;
                }
            }
        }
        .btns{
            display: flex;
            align-items: center;
            margin-top: 25px;
            width: 100%;
            justify-content: center;
            button{
                margin-right: 10px;
                width: auto;
            }
        }
    }
    .error{
        font-size: 12px;
        color: var(--color-main);
        font-weight: var(--font-weight-lg);
    }
`
    
const YukVerenKayitModal = () => {
    const { selectedProject } = useSelector(state => state.isOrtaklari)

    const {modalLocation } = useSelector(state => state.modal)
    const dispatch = useDispatch()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();
    const [isSubmit, setIsSubmit] = useState(false)

    const [phoneValue, setPhoneValue] = useState("")
    const [search, setSearch] = useState("")

    const [kayitData, setKayitData] = useState({
        yetkiliUsername:"",
        yetkiliMail:"",
        yetkiliPhoneNumber:"",
        vergiNo:"",
        firmaName:"",
        password: "",
        passwordAgain:"",
        projectName: ""
    })

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
    lockScroll()

    return () => {
        unlockScroll()
    }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleSubmit = () => {
        setIsSubmit(true)
        if(kayitData?.yetkiliUsername, kayitData?.yetkiliMail, kayitData?.yetkiliPhoneNumber, kayitData?.vergiNo){
            const addData = {
                id: selectedProject.id,
                yetkiliUserName: kayitData?.yetkiliUsername,
                yetkiliMail: kayitData?.yetkiliMail,
                yetkiliPhoneNumber: kayitData?.yetkiliPhoneNumber?.slice(2),
                firmaName: kayitData?.firmaName,
                taxNo: kayitData?.vergiNo,
                companyProjectName: selectedProject?.projectName,
                digitalLogisticId: selectedProject?.digitalLogisticId,
            }
            dispatch(updateCompanyProject(addData))
            
        }
    }

    const handleChange = ({e, type}) => {
        if(type === "number"){
            setKayitData((prev) => ({...prev, [e.target.name]: e.target.value.replace(/[^0-9]/g, '')}))
        }
        else{
            setKayitData((prev) => ({...prev, [e.target.name]: e.target.value}))
        }
    }

  return (
    <Container>
        <div className="modal" onClick={(e)=> e.stopPropagation()}>
            <PageTopTitle isDiffPage title={"Yük Veren Kayıt"} />
            <div className="form-container">
                <div className="form">
                    <div className="input-grp">
                        <InputText data={kayitData.yetkiliUsername} setData={(e) => handleChange({e, type: ""})} labelText="Yetkili Adı Soyadı" inputWidth={"100%"} name={"yetkiliUsername"}/>
                        {isSubmit && !kayitData.yetkiliUsername &&
                            <span className="error">Yetkili adı ve soyadını giriniz.</span>
                        }
                    </div>
                    
                    <div className="input-grp">
                        <InputMail data={kayitData.yetkiliMail} setData={(e) => handleChange({e, type: ""})} labelText="Yetkili Mail Adresi" inputWidth={"100%"} name={"yetkiliMail"}/>
                        {isSubmit && !kayitData.yetkiliMail &&
                            <span className="error">Yetkili mailini giriniz.</span>
                        }
                    </div>
                    
                    <div className="input-grp">
                        <InputPhoneFormat data={phoneValue} setData={setPhoneValue} labelText="Yetkili Telefonu" inputWidth={"100%"} name={"yetkiliPhoneNumber"}/>
                        {isSubmit && !phoneValue &&
                            <span className="error">Yetkili telefon numarasını giriniz.</span>
                        }
                    </div>
                    
                    <div className="input-grp">
                        <InputText max={11} data={kayitData.vergiNo} setData={(e) => handleChange({e, type: "number"})} labelText="Firma/Koop. Vergi No" inputWidth={"100%"} name={"vergiNo"}/>
                        {isSubmit && !kayitData.vergiNo &&
                            <span className="error">Vergi numarasını giriniz.</span>
                        }
                    </div>
                    
                    <div className="input-grp">
                        <InputText auto={"off"} data={kayitData.firmaName} setData={(e) => handleChange({e, type: ""})} labelText="Firma/Koop. Adı/Ünvanı" inputWidth={"100%"} name={"firmaName"}/>
                        {isSubmit && !kayitData.firmaName &&
                            <span className="error">Firma adını giriniz.</span>
                        }
                    </div>

                    <div className="input-grp">
                        <InputText disabled={true} data={selectedProject.projectName} setData={(e) => handleChange({e, type: ""})} labelText="Proje İsmi" inputWidth={"100%"} name={"projectName"}/>
                    </div>
                    
                    <div className="btns">
                        <Button width="150px" handleClick={handleSubmit} padding="10px" background="#fff" color={"#E85446"}>Kaydet</Button>
                        <Button width="150px" handleClick={() => {dispatch(showModal(null)); dispatch(setSearchCompany(null)); dispatch(setIsSearchCompany(false))}} padding="10px" background="#fff" color={"#E85446"}>Kapat</Button>
                    </div>
                </div>
            </div>
            
        </div>
    </Container>
  )
}

export default YukVerenKayitModal